import classNames from "classnames";
import React, { useState } from "react";
import { IMenuFooter, modelMenuFooter } from "./data";
import styles from "./footer.module.scss";
const FooterMenu = () => {
  const [dataMenu] = useState<IMenuFooter[]>(modelMenuFooter);
  return (
    <div className={styles["footer-menu"]}>
      <div className={styles["container"]}>
        <div className="row">
          {dataMenu.map((footer, index) => (
            <React.Fragment key={index}>
              <div
                className={classNames("col-lg col-md-4 col-6", {
                  "d-block d-lg-none": index === 5,
                })}
              >
                <div className={styles.title}>{footer.title}</div>
                <ul>
                  {footer.menu.map((m, i) => (
                    <li key={i}>
                      <a href={m.href} target="_blank" rel={`noreferrer ${m.rel}`}>
                        {m.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              {(index + 1) % 2 === 0 && dataMenu[index + 1] ? (
                <hr
                  style={{ border: "1px solid #24282e", borderTopColor: "#000", width: "100%", margin: "25px 0 30px" }}
                  className="d-block d-md-none"
                />
              ) : (
                ""
              )}
            </React.Fragment>
          ))}
          <div className={classNames(styles["col-w-20"], "col-6 col-md-4 d-lg-none d-block")}>
            <div className={styles.title}>Trợ giúp</div>
            <ul>
              <li>
                <a
                  href="https://help.sapo.vn/?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_trung_tam_tro_giup"
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                >
                  Trung tâm trợ giúp
                </a>
              </li>
              <li>
                <a
                  href="https://help.sapo.vn/tong-quan-ve-tai-khoan-dang-nhap-phan-mem-sapo?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_huong_dan_dang_nhap_sapo"
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                >
                  Hướng dẫn đăng nhập Sapo
                </a>
              </li>
              <li>
                <a
                  href="https://help.sapo.vn/dieu-khoan-va-dieu-kien-su-dung?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_dieu_khoan_dieu_kien_su_dung"
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                >
                  Điều khoản & Điều kiện sử dụng
                </a>
              </li>
              <li>
                <a
                  href="https://help.sapo.vn/chinh-sach-bao-ve-du-lieu-ca-nhan?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_chinh_sach_bao_ve_du_lieu_ca_nhan"
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                >
                  Chính sách bảo vệ dữ liệu cá nhân
                </a>
              </li>
              <li>
                <a
                  href="https://drive.google.com/file/d/1rxszgN-JqCDLALdT0rSouOKmLPNoTFC1/view"
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                >
                  Dịch vụ hoàn thiện website
                </a>
              </li>
              <li>
                <a
                  href="https://www.sapo.vn/lien-he.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_brand_lien_he"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                >
                  Liên hệ
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterMenu;
